<template>
    <Lightbox
            id="addMediaToCampaign"
            headline="Add Media to campaign"
            :large="true"
            @lightboxclosing="close"
    >
        <a slot="open-template" ref="modalOpen"></a>
        <div slot="body" class="row">
            <div class="text-center p-m" v-if="loading">
                <span>Loading</span>
                <i class="fa fa-cog fa-spin"></i>
            </div>
            <ul class="list-group white-bg border-top-bottom" style="height: 50vh; overflow-y: auto;" v-else>
                <li
                        class="list-group-item selectable"
                        :class="{'bg-primary': selectedCampaign == campaign.id}"
                        @click.prevent="selectedCampaign = campaign.id"
                        v-for="campaign in campaigns"
                >{{ campaign.title }}
                </li>
            </ul>
        </div>
        <div slot="footer">
            <button type="button" class="btn btn-white pull-left" data-dismiss="modal"
                    v-text="__('scoop-os.common.close')"></button>
            <button
                    type="button"
                    class="btn btn-primary"
                    v-if="selectedCampaign && !loading"
                    @click="assignToCampaign"
            >Assign to campaign
            </button>
        </div>
    </Lightbox>
</template>

<script>
export default {
    props: {
        openModal: {
            type: Boolean
        }
    },
    data() {
        return {
            baseUrl: Scoop.baseUrl,
            loading: true,
            campaigns: [],
            selectedCampaign: null,
        }
    },
    methods: {
        fetchData() {
            axios.get(this.baseUrl + '/scoop/media-campaigns').then((response) => {
                this.campaigns = response.data;
                this.loading = false;
            }).catch(error => {
                toastr.error(error);
            })
        },
        assignToCampaign() {
            this.loading = true;

            axios.post(this.baseUrl + '/scoop/media-campaigns', {
                campaign: this.selectedCampaign
            }).then((response) => {
                if (response.data) {
                    window.location.href = `/scoop/campaigns/${this.selectedCampaign}/edit`
                } else {
                    toastr.error('Something went wrong');
                }
            }).catch(error => {
                toastr.error(error);
            })
        },
        close() {
            this.$emit('close');
        }
    },
    watch: {
        openModal(openModal) {
            if (openModal) {
                this.fetchData();
                this.$refs.modalOpen.click();
            }
        }
    },
}
</script>